import {type Theme, useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import type {SxProps} from '@mui/system';
import type {FC, ReactElement} from 'react';
import IsoLogo from '@/components/common/logos/IsoLogo';

export type Props = {
  children?: ReactElement;
};

const FullScreenWrapper: FC<Props> = ({children}) => {
  const theme = useTheme();

  return (
    <Box sx={styles(theme).container}>
      <Box sx={styles(theme).logoContainer}>
        <IsoLogo />
      </Box>
      {children}
    </Box>
  );
};

export default FullScreenWrapper;

const styles = (theme: Theme): Record<string, SxProps> => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
    height: '100vh',
    width: '100%',
    background: theme.palette.primary.gradient,
    top: 0,
    left: 0,
  },
  logoContainer: {
    position: 'absolute',
    bottom: 8,
    left: {xs: 0},
    width: {xs: '120px', sm: '150px', lg: '200px'},
    zIndex: 50,
    mx: 2,
  },
});
